const STORAGE_KEY = 'it-ticketing-active-customer-id'

/**
 * The unfiltered read scope: an admin's "All customers" choice, and also what
 * CustomerPicker sets for a plain requester (whose own tickets can sit under
 * any customer; RLS does the limiting). Not a real customer id and
 * never written to a database row — see itTicketingOrgIdForRead() in
 * ticketingService.ts for how writes are protected from ever seeing it.
 */
export const ALL_CUSTOMERS_SENTINEL = '__all__'

/**
 * Which IT Ticketing customer the signed-in user is currently viewing,
 * persisted per-browser via localStorage — deliberately NOT the same
 * mechanism as the app-wide PPM portfolio/org picker (@/lib/orgContext's
 * getCurrentOrganizationId, key 'ppm-organization-id'). That key picks
 * between PPM portfolio orgs (Gentex, Boeing, ...); this one picks between
 * IT Ticketing support customers. The two concepts are unrelated, and
 * sharing a key would mean switching one silently switched the other.
 *
 * Private-browsing / blocked-storage safe: every access is try/catch
 * wrapped, matching the now-removed useTicketingTheme.ts's localStorage
 * style (a per-viewer, never-synced preference).
 */
export function getActiveTicketingCustomerId(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY) || null
  } catch {
    return null
  }
}

export function setActiveTicketingCustomerId(id: string | null): void {
  try {
    if (id) localStorage.setItem(STORAGE_KEY, id)
    else localStorage.removeItem(STORAGE_KEY)
  } catch {
    // Private browsing / blocked storage — the picker still works for this
    // page load, it just won't be remembered next time.
  }
}
